import Confirm from 'src/views/confirm';

module.exports = _.extend({
  initialize: function () {},

  show: function ({ labels, onConfirm, onCancel }) {
    Confirm.mountApp({ labels, onConfirm, onCancel });
  }
}, Backbone.Events);
